import React from 'react';
import { Link } from 'react-router-dom';

function ClientGuidePage() {
  const benefits = [
    { title: 'Find Your Expert', desc: 'Browse through diverse verified therapists based on expertise and budget.' },
    { title: 'Secure Booking', desc: 'Choose a slot and pay securely via our integrated gateway.' },
    { title: 'Join Session', desc: 'Access your session link directly from your dashboard or via WhatsApp.' },
    { title: 'Digital Library', desc: 'Get access to curated workbooks and calming resources anytime.' }
  ];

  return (
    <div style={{ background: '#f8fbff', minHeight: '100vh' }}>
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-2-2.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Client Wellness Journey</h2>
            <ul className="thm-breadcrumb">
              <li><Link to="/">Home</Link></li>
              <li><span>/</span></li>
              <li><span>Wellness Guide</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section style={{ padding: '100px 0' }}>
        <div className="container">
          <div className="row align-items-center flex-row-reverse">
            {/* Guide Book Visual Placeholder */}
            <div className="col-lg-5 mb-5 mb-lg-0 wow fadeInRight">
              <div style={{
                position: 'relative',
                background: '#fff',
                padding: '40px',
                borderRadius: '24px',
                boxShadow: '0 30px 60px rgba(59, 130, 246, 0.1)',
                border: '1px solid #eef2ff',
                textAlign: 'center'
              }}>
                <div style={{ 
                  width: '100%', 
                  height: '350px', 
                  background: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#fff',
                  marginBottom: '30px',
                  boxShadow: 'inset 0 0 50px rgba(0,0,0,0.1)'
                }}>
                   <span style={{ fontSize: '5rem' }}>📒</span>
                   <h3 style={{ color: '#fff', fontWeight: 800, marginTop: '20px' }}>Your Healing<br/>Journal</h3>
                   <p style={{ opacity: 0.8 }}>Wellness Guide 2026</p>
                </div>
                <h4 style={{ fontWeight: 800, color: '#1e3a8a' }}>The Path to Inner Peace</h4>
                <p style={{ color: '#6b7280' }}>Everything you need to know about starting your mental health journey with us.</p>
                <button className="thm-btn" style={{ borderRadius: '12px', padding: '12px 30px', background: '#3b82f6' }}>Open Wellness Guide</button>
              </div>
            </div>

            {/* Steps and Content */}
            <div className="col-lg-7 wow fadeInLeft">
              <div style={{ paddingRight: '40px' }}>
                <span style={{ color: '#3b82f6', fontWeight: 800, fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '2px' }}>Start your journey</span>
                <h2 style={{ fontSize: '2.8rem', fontWeight: 900, color: '#1f2937', margin: '15px 0 30px' }}>Your Path to <span style={{ color: '#3b82f6' }}>Mindfulness</span> Begins Here</h2>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px' }}>
                   {benefits.map((b, i) => (
                     <div key={i} style={{ padding: '25px', background: '#fff', borderRadius: '16px', border: '1px solid #f3f4f6', boxShadow: '0 4px 10px rgba(0,0,0,0.02)' }}>
                        <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{i === 0 ? '🔍' : i === 1 ? '💳' : i === 2 ? '🎥' : '📚'}</div>
                        <h5 style={{ fontWeight: 800 }}>{b.title}</h5>
                        <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem' }}>{b.desc}</p>
                     </div>
                   ))}
                </div>

                <div style={{ background: '#eff6ff', padding: '30px', borderRadius: '20px', border: '1px solid #bfdbfe', marginBottom: '40px' }}>
                  <h4 style={{ fontWeight: 800, color: '#1e3a8a' }}>🌈 You Are Not Alone</h4>
                  <p style={{ color: '#4b5563', margin: 0 }}>Join a community of thousands who have found support, growth, and relief through our platform. Healing starts with a single step.</p>
                </div>

                <Link to="/register/client" className="thm-btn" style={{ padding: '18px 50px', fontSize: '1.2rem', fontWeight: 800, borderRadius: '18px', background: '#3b82f6' }}>Register as Client</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ClientGuidePage;
